export class KeyMessageGroupApi {
    keyMessageGroupTitle: string;
    keyMessageGroupSummary?: string;
    keyMessageProminenceSum?: number;
    examples?: string[] = [];

    // F/E only
    selected?: boolean = false;
}
